const fileToDataURLString = (inputFile: File): Promise<string> => {
  const fileReader = new FileReader();

  return new Promise(resolve => {
    fileReader.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      resolve(fileReader.result?.toString() || '');
    };
    fileReader.readAsDataURL(inputFile);
  });
};

const fileIsAnimatedPNG = (base64EncodedString: string) => {
  const pngDataURLPrefix = 'data:image/png;base64,';
  const parsedString = atob(base64EncodedString.replace(pngDataURLPrefix, ''));
  const animationControlChunkPrefix = 'acTL';
  return parsedString.includes(animationControlChunkPrefix);
};

export { fileToDataURLString, fileIsAnimatedPNG };
